import React from 'react';
import { Box } from '@mui/material';
import { SparkTabs } from 'sharedComponents/UI';

import SparkBuilderConfigureOutput from './SparkBuilderConfigureOutput';

function SparkBuilderConfiguration() {
  const [selectedItemIndex, setSelectedItemIndex] = React.useState(0);
  const tabItems = [
    {
      label: 'Output',
      content: <SparkBuilderConfigureOutput />,
    },
  ];

  const onSparkTabChange = (tabIndex: number) => {
    setSelectedItemIndex(tabIndex);
  };

  return (
    <Box position='relative' height='100%'>
      <SparkTabs
        tabItems={tabItems}
        selectedItemIndex={selectedItemIndex}
        onChange={onSparkTabChange}
        tabPanelStyles={{ height: '100%', padding: '0px' }}
      />
    </Box>
  );
}

export default SparkBuilderConfiguration;
